import type { FC, ReactNode } from "react";
import { Header, ListBoxSection } from "react-aria-components";
import {
  searchModalSectionClassName,
  searchModalSectionHeaderClassName,
} from "./searchModalSection.js";

export interface SearchModalListBoxSectionProps {
  id: string;
  title?: string;
  children: ReactNode;
}

/** A group of rows within the modal's single listbox, optionally titled. */
export const SearchModalListBoxSection: FC<SearchModalListBoxSectionProps> = (
  props,
) => {
  const { id, title, children } = props;

  return (
    <ListBoxSection
      id={id}
      className={searchModalSectionClassName}
      data-has-title={title ? "" : undefined}
    >
      {title ? (
        <Header className={searchModalSectionHeaderClassName}>{title}</Header>
      ) : null}
      {children}
    </ListBoxSection>
  );
};
